export default __webpack_public_path__ + "static/20-b8d8b3e64e158c917454d308d30f82a8.webp";